(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('AutomaticAnswersTabController', automaticAnswersTabController);

  automaticAnswersTabController.$inject = ['$rootScope', 'CompanyService', 'NotificationService'];

  function automaticAnswersTabController ($rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.automaticAnswersSett');

    var vmAutomaticAnswersTab = this;

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmAutomaticAnswersTab.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmAutomaticAnswersTab.allow = function () {
      CompanyService
        .saveMetadata(vmAutomaticAnswersTab.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
